export default {
  'goldkid-open-button:text': 'Балаға арналған Kaspi Gold ресімдеу',
  'goldkid-open:agreement': 'Батырманы басып, <span class="text-action-link link-300">жеке деректерім</span> өңделетініне келісемін',
  'goldkid-open:get-card': 'Карта алу'
}
